

export default function Spinner() {
  return (
    <div style={{ display:'flex', justifyContent:'center', padding:'60px' }}>
      <div style={{ width:'40px', height:'40px', border:'4px solid #eee', borderTop:'4px solid #e94560', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
